export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <span className="font-heading text-xl font-bold text-background-50">
              爱漫画网
            </span>
            <p className="mt-3 text-sm text-background-400 leading-relaxed">
              爱漫画网是漫画爱好者首选的在线阅读平台，提供韩漫、日漫、国漫等海量免费漫画资源。支持下拉式沉浸阅读，追更收藏一站搞定。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2">
              <a href="#hero" className="text-sm text-background-400 hover:text-background-200 transition-colors">首页</a>
              <a href="#features" className="text-sm text-background-400 hover:text-background-200 transition-colors">平台特色</a>
              <a href="#about" className="text-sm text-background-400 hover:text-background-200 transition-colors">关于我们</a>
              <a href="#faq" className="text-sm text-background-400 hover:text-background-200 transition-colors">常见问题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              <a href="#index" className="text-sm text-background-400 hover:text-background-200 transition-colors">恋爱漫画</a>
              <a href="#index" className="text-sm text-background-400 hover:text-background-200 transition-colors">热血漫画</a>
              <a href="#index" className="text-sm text-background-400 hover:text-background-200 transition-colors">玄幻漫画</a>
              <a href="#index" className="text-sm text-background-400 hover:text-background-200 transition-colors">古风漫画</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-500">更多合作伙伴即将入驻</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2019-2026 爱漫画网 版权所有 | 免费漫画 · 每日追更 · 下拉式阅读
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-background-500">韩漫</span>
            <span className="text-xs text-background-500">日漫</span>
            <span className="text-xs text-background-500">国漫</span>
            <span className="text-xs text-background-500">免费漫画</span>
            <span className="text-xs text-background-500">漫画全集</span>
          </div>
        </div>
      </div>
    </footer>
  );
}